"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgOpenAlert = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("path", { fill: "#fff", fillOpacity: 0.48, fillRule: "evenodd", d: "M2.32 10.985a1.1 1.1 0 0 1 .769-.318H9.66a1 1 0 0 0 0-2H3.09A3.09 3.09 0 0 0 0 11.749v11.736a3.09 3.09 0 0 0 3.089 3.091h5.164L6.97 30h-.64a1 1 0 0 0 0 2h11.993a1 1 0 0 0 0-2h-.64L16.4 26.576h5.164a3.09 3.09 0 0 0 3.089-3.09v-1.82a1 1 0 1 0-2 0v1.82a1.09 1.09 0 0 1-1.09 1.09H3.09a1.09 1.09 0 0 1-1.09-1.09V11.753c0-.289.116-.565.32-.769m8.034 15.682L9.104 30h6.444l-1.25-3.333z", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#fff", fillOpacity: 0.48, fillRule: "evenodd", d: "M5.33 15.333a1 1 0 0 1 1-1h7.329a1 1 0 0 1 0 2h-7.33a1 1 0 0 1-.999-1M5.33 20a1 1 0 0 1 1-1h3.998a1 1 0 0 1 0 2H6.33a1 1 0 0 1-1-1", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M17.343 14.657A8 8 0 1 1 28.658 3.343a8 8 0 0 1-11.315 11.314M23.995 9c0 .437-.363.8-.8.8a.797.797 0 0 1-.79-.8V5.8c0-.437.342-.8.79-.8s.81.363.8.8zm-.758 1.61c.086 0 .171.011.256.054.512.128.907.576.907 1.141 0 .662-.544 1.195-1.205 1.195A1.193 1.193 0 0 1 22 11.805c0-.576.416-1.034.96-1.152a.6.6 0 0 1 .192-.042l.018-.004q.016-.006.035-.007.009.001.016.005.009.005.016.006", clipRule: "evenodd" })));
exports.default = SvgOpenAlert;
